module.exports = __webpack_public_path__ + "img/Freelance-znak_negativ.826fcbe.svg";